import { Color, TextVariant } from 'styles/types'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { DefaultTheme } from 'styled-components'

type Align = 'flex-start' | 'flex-end' | 'center' | 'stretch'

interface IconWithTextProps {
    isIconDisabled?: boolean
    icon?: string
    iconAlt?: string
    textHighlighted?: React.ReactNode
    text?: React.ReactNode
    fontVariant?: TextVariant
    align?: Align | [Align, Align]
    textColor?: Color
    textHighlightedColor?: Color
    className?: string
    gap?: number | [number, number]
    theme?: DefaultTheme
}

const IconWithText = ({
    icon,
    iconAlt,
    textHighlighted,
    text,
    fontVariant = 'body',
    align,
    textColor = 'grayscale_500',
    textHighlightedColor = 'grayscale_900',
    className = '',
    isIconDisabled = false,
    gap = 16,
    theme,
}: IconWithTextProps) => (
    <Box
        direction="row"
        justify="flex-start"
        align={align || 'center'}
        gap={gap}
        className={className}
        isFullWidth={true}
    >
        {!isIconDisabled && <img src={icon} alt={iconAlt} />}
        <Text variant={fontVariant} color={textColor} theme={theme}>
            {!!textHighlighted && (
                <Text
                    as="span"
                    variant={fontVariant}
                    color={textHighlightedColor}
                >
                    {textHighlighted}
                </Text>
            )}{' '}
            {text}
        </Text>
    </Box>
)

export default IconWithText
